import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";
import { useTheme } from "@/themeConfigs/ThemeContext";
import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";

interface CarsAllocatedComparisonChartProps {
  data: { week: string; vehicleCount: number }[];
}

export function CarsAllocatedComparisonChart({
  data,
}: CarsAllocatedComparisonChartProps) {
  const { theme } = useTheme();
  const chartConfig = {
    vehicleCount: {
      label: "Vehicle Count",
      color: theme.colors.primary,
    },
  } satisfies ChartConfig;

  return (
    <div className="flex flex-col items-center">
      <ChartContainer
        config={chartConfig}
        className="min-h-[350px] w-full flex justify-center items-center"
      >
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 0, bottom: 10 }}
        >
          <CartesianGrid vertical={false} />
          <YAxis dataKey="vehicleCount" />
          <XAxis
            dataKey="week"
            tickLine={true}
            tickMargin={10}
            axisLine={true}
          />
          <ChartTooltip content={<ChartTooltipContent />} />
          <ChartLegend content={<ChartLegendContent />} />
          <Bar
            dataKey="vehicleCount"
            fill={theme.colors.primary}
            radius={4}
            barSize={30}
          />
        </BarChart>
      </ChartContainer>
    </div>
  );
}
